import * as yup from 'yup';
import { validation } from '../constants/appConstants';

export const signinSchema = yup.object().shape({
  email: yup
    .string()
    .required('Field cannot be left empty')
    .max(validation.emailMax, `${validation.emailMax} chars are allowed`)
    .email('Invalid email pattern'),

  password: yup.string().required('Field cannot be left empty'),
  // .min(validation.passwordMin, `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`)
  // .max(validation.passwordMax, `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`)
  // .matches(/[A-Z]/, `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`)
  // .matches(/[a-z]/, `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`)
  // .matches(/[!@#$%^&*(),.?":{}|<>]/, `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`)
});

export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .required('Field cannot be left empty')
    .max(validation.emailMax, `${validation.emailMax} chars are allowed`)
    .email('Invalid email pattern'),
});

export const otpSchema = yup.object().shape({
  otp: yup
    .string()
    .required('Field cannot be left empty')
    .min(validation.otpCodeMin)
    .max(validation.otpCodeMax),
});

export const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required('Field cannot be left empty')
    .min(
      validation.passwordMin,
      `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`
    )
    .max(
      validation.passwordMax,
      `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`
    )
    .matches(
      /[A-Z]/,
      `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`
    )
    .matches(
      /[a-z]/,
      `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`
    )
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`
    ),

  confirmPassword: yup
    .string()
    .required('Field cannot be left empty')
    .min(
      validation.passwordMin,
      `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`
    )
    .max(
      validation.passwordMax,
      `Password length must be atleast ${validation.passwordMin} char and must include an upper case and lower case char`
    )
    .oneOf([yup.ref('password'), null], 'Passwords do not match'),
});
